// sort array ascending
const asc = arr => arr.sort((a, b) => a - b);

const sum = arr => arr.reduce((a, b) => a + b, 0);

const mean = arr => sum(arr) / arr.length;

// sample standard deviation
export const std = (arr) => {
    const mu = mean(arr);
    const diffArr = arr.map(a => (a - mu) ** 2);
    return Math.sqrt(sum(diffArr) / (arr.length - 1));
};

const quantile = (arr, q) => {
    const sorted = asc(arr);
    const pos = (sorted.length - 1) * q;
    const base = Math.floor(pos);
    const rest = pos - base;
    if (sorted[base + 1] !== undefined) {
        let d = Number(rest * (sorted[base + 1] - sorted[base]))
        let d1 = Number(sorted[base]);
        return d + d1;
    } else {
        return sorted[base];
    }
};

export const q25 = arr => quantile(arr, .25);

export const q50 = arr => quantile(arr, .50);

export const q75 = arr => quantile(arr, .75);

export const q90 = arr => quantile(arr, .90);

export const median = arr => q50(arr);